<template>
    <div class="activity_answer">
        <div class="header">
            <div class="mvbutton small text-white" @click="showrule=true">答题规则</div>
        </div>
        <div class="body">
            <Questions @submitAnswer="submitAnswer" :questions="questions" v-if="questions.length"
                       @selectAnswer="selectAnswer" :type="type" :answerInfo="answerInfo"></Questions>
        </div>
        <van-overlay :show="showrule"  >
            <div class="wrapper">
                <div class="block">
                    <div class="block_header">
                        <div>规则说明</div>
                        <img :src="require('assets/img/mwap/colse.png')" alt="" @click="showrule = false">
                    </div>
                    <div class="block_body" v-html="rule"></div>                    
                </div>                
            </div>
        </van-overlay>

    </div>
</template>

<script>
    import './index.less'
    import Questions from './questions/index'
    import { Overlay } from 'vant';  

    export default {
        name: "answer",
        data() {
            return {
                answerInfo: {
                    correctcount: 0,
                    score: 0
                },
                type: 'answerList',
                showrule: false,
                rule: "",
                questions: [],
                questionname: ""
            }
        },
        components: {
            vanOverlay:Overlay,
            Questions
        },
        methods: {
            submitAnswer() {
                this.$toast.loading({duration: 0, loadingType: "spinner"})
                let answer = [];
                let correctcount = 0;
                for (var i in this.questions) {
                    if (this.questions[i]['correct']) correctcount++
                    if (this.questions[i]['selected'] !== undefined) {
                        answer.push({
                            qid: this.questions[i].qid,
                            answer: this.questions[i].selected
                        })
                    } else {
                        this.$toast.clear();
                        this.$toast.fail("请回答完所有问题后再提交")
                        return;
                    }
                }
                if (answer.length) {
                    this.$api.answer.submitQuestions({aid:this.$route.params.acid,answer: JSON.stringify(answer)}).then((res) => {
                        if (res.status * 1 === 200) {
                            this.questions = [1]
                            this.answerInfo = {
                                correctcount,
                                score: res.data.score
                            }
                            this.type = 'answerFinsh';
                            this.$storage.remove(this.questionname)

                        }
                        this.$toast.clear();
                    })
                }

            },
            selectAnswer(key, ckey) {
                var currentquestion = this.questions;
                currentquestion[key]['selected'] = ckey + 1
                var courrent = this.cf.AesDecrypt(currentquestion[key]["answer"])
                if (ckey + 1 == courrent) {
                    currentquestion[key]['correct'] = true;
                } else {
                    currentquestion[key]['correct'] = false;
                }
                this.$set(this.questions, key, currentquestion[key]);
                this.$storage.set(this.questionname, currentquestion)
            },
            getQuestions() {
                this.$toast.loading({duration: 0, loadingType: "spinner"})
                //查看本地缓存
                this.$api.answer.questions({aid:this.$route.params.acid}).then((res) => {
                    if (res.status * 1 === 200) {
                        return res.data;
                    } else {
                        this.$toast.clear();
                    }
                }).then((apires) => {

                    this.rule = apires.rule;
                    if(apires.qtoday && apires.qtoday*1===1){
                        this.type = 'answered';
                        this.questions = ['1']
                        this.$toast.clear();
                        return
                    }
                    this.questions = apires.questions;
                    this.$storage.set(this.questionname, apires.questions)
                    // this.$storage.get(this.questionname).then((res) => {
                    //     if (res) {
                    //         this.questions = res
                    //     } else {
                    //         this.questions = apires.questions;
                    //         this.$storage.set(this.questionname, apires.questions)
                    //     }
                    // })
                    this.$toast.clear();

                })


            }
        },
        mounted() {
            this.$nextTick(() => {
                let d = new Date();
                this.questionname = [d.getFullYear(), d.getMonth(), d.getDay()].join("-")
                this.getQuestions();
            })
        }
    }
</script>
